module.exports = __webpack_public_path__ + "static/media/message-profile-icon.2145d8d9.svg";